import { ia, iaRa } from 'lib/helpers/utility';

import { toMinutes } from 'components/practice/Settings/components/PracticeDetails/lib/workingHoursUtils';
import { showAlert } from 'components/shared/Alert/Alert';

export const useTimeUpdate = ({ day, updateAvailableTimes }) => {
  const handleTimeChange = (dayName, typeKey, field, value) => {
    const startsAt = day?.[typeKey]?.starts_at;
    const endsAt = day?.[typeKey]?.ends_at;

    if (field === 'ends_at') {
      if (startsAt && toMinutes(startsAt) > toMinutes(value)) {
        showAlert({
          title: 'End time cannot be before start time',
          color: 'danger'
        });
        return;
      }
    }

    if (field === 'starts_at' && endsAt && toMinutes(value) > toMinutes(endsAt)) {
      showAlert({
        title: 'Start time cannot be after end time',
        color: 'danger'
      });
      return;
    }

    updateAvailableTimes((prev) =>
      iaRa(prev).map((d) => {
        if (d.day !== dayName) return d;

        const currentRange = d[typeKey] || {};
        const nextRange = {
          ...currentRange,
          [field]: value
        };

        return {
          ...d,
          [typeKey]: nextRange
        };
      })
    );
  };

  const handleAddBreak = (dayName) => {
    updateAvailableTimes((prev) =>
      iaRa(prev).map((d) => {
        if (d.day !== dayName) return d;

        const existing = ia(d.break) ? d.break : [];
        const newBreak = {
          id: Math.floor(Math.random() * 99999),
          starts_at: null,
          ends_at: null
        };

        return {
          ...d,
          break: [...existing, newBreak]
        };
      })
    );
  };

  const handleBreakChange = (dayName, breakId, field, value) => {
    const breakData = day.break?.find((b) => b.id === breakId);
    const startsAt = breakData?.starts_at;
    const endsAt = breakData?.ends_at;

    if (field === 'ends_at') {
      if (startsAt && toMinutes(startsAt) > toMinutes(value)) {
        showAlert({
          title: 'End time cannot be before start time',
          color: 'danger'
        });
        return;
      }
    }

    if (field === 'starts_at' && endsAt && toMinutes(value) > toMinutes(endsAt)) {
      showAlert({
        title: 'Start time cannot be after end time',
        color: 'danger'
      });
      return;
    }

    updateAvailableTimes((prev) =>
      iaRa(prev).map((d) => {
        if (d.day !== dayName) return d;
        if (!ia(d.break)) return d;

        return {
          ...d,
          break: iaRa(d.break).map((b) =>
            b.id === breakId
              ? {
                  ...b,
                  [field]: value
                }
              : b
          )
        };
      })
    );
  };

  const handleRemoveBreak = (dayName, breakId) => {
    updateAvailableTimes((prev) =>
      iaRa(prev).map((d) => {
        if (d.day !== dayName) return d;
        if (!ia(d.break)) return d;

        const filtered = d.break.filter((b) => b.id !== breakId);
        if (filtered.length) {
          return {
            ...d,
            break: filtered
          };
        } else {
          const updated = { ...d };
          delete updated.break;
          return updated;
        }
      })
    );
  };

  const handleBreakToggle = (enabled) => {
    if (enabled) {
      handleAddBreak(day.day);
    } else {
      updateAvailableTimes((prev) =>
        prev.map((entry) => {
          if (entry.day === day.day) {
            const updated = { ...entry };
            delete updated.break;
            return updated;
          }
          return entry;
        })
      );
    }
  };

  return {
    handleTimeChange,
    handleAddBreak,
    handleBreakChange,
    handleRemoveBreak,
    handleBreakToggle
  };
};
